import { reactive } from "vue";
export const lstore = reactive({});
export const setState = (o, n) => {
  this.state[o] = {};
  this.state[o] = Object.assign({}, n);
};
